const moment = require("moment");
const { getSpotLink, nameEncode } = require("./linkGenerator");

export const getTemplateByType = (type, docs) => {
  switch (type) {
    case "media":
      return templateGeneral("media", docs);

    case "NGO":
      return templateGeneral("NGO", docs);

    case "business":
      return templateGeneral("business", docs);

    case "government":
      return templateGeneral("government", docs);

    case "hotSpot":
      return templateHotSpots("hotSpot", docs);

    case "greenSpot":
      return templateHotSpots("greenSpot", docs);

    case "news":
      return templateNews("news", docs);
    case "blog":
      return templateBlog("blog", docs);
  }
};

const templateHotSpots = (type, docs) => {
  let urls = "";
  for (let orgToFile of docs) {
    const lastmod = moment(orgToFile.date).isValid()
      ? moment(orgToFile.date).format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD");

    urls +=
      // eslint-disable-next-line no-multi-str
      `
   <url>\
      <loc>${getSpotLink(type, orgToFile.name, orgToFile.key)}</loc>\
     <lastmod>${lastmod}</lastmod>\
      <priority>0.9</priority>\
   </url>\
`;
  }
  const fileValue = `<?xml version="1.0" encoding="UTF-8"?>\
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">\
${urls}
</urlset> `;

  return fileValue;
};

const templateGeneral = (type, docs) => {
  let urls = "";
  for (let orgToFile of docs) {
    urls +=
      // eslint-disable-next-line no-multi-str
      `
   <url>\
      <loc>${getSpotLink(type, orgToFile.name, orgToFile.key)}</loc>\
     <lastmod>${moment(orgToFile.date).format("YYYY-MM-DD")}</lastmod>\
      <priority>0.8</priority>\
   </url>\
`;
  }
  const fileValue = `<?xml version="1.0" encoding="UTF-8"?>\
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">\
${urls}
</urlset> `;

  return fileValue;
};

const templateNews = (type, docs) => {
  let urls = "";
  for (let orgToFile of docs) {
    urls +=
      // eslint-disable-next-line no-multi-str
      `<url>\
      <loc>https://www.ecohubmap.com/the-news/${nameEncode(orgToFile.title)}/${
        orgToFile.key
      }</loc>\
      <news:news> \
      <news:publication> \
      <news:name>ecohubmap</news:name>\
      <news:language>en</news:language>\
      </news:publication>\
      <news:publication_date>${moment(orgToFile.date).format(
        "YYYY-MM-DD"
      )}</news:publication_date>\
      <news:title>${nameEncode(orgToFile.title)} </news:title>\
      </news:news> \
      <lastmod>${moment(orgToFile.date).format("YYYY-MM-DD")}</lastmod>\
      <priority>0.8</priority>\
   </url>\
`;
  }
  const fileValue = `<?xml version="1.0" encoding="UTF-8"?>\
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:news="http://www.google.com/schemas/sitemap-news/0.9">\
${urls}
</urlset> `;

  return fileValue;
};
const templateBlog = (type, docs) => {
  let urls = "";
  for (let orgToFile of docs) {
    urls +=
      // eslint-disable-next-line no-multi-str
      `<url>\
      <loc>https://www.ecohubmap.com/post/${nameEncode(orgToFile.title)}/${
        orgToFile.key
      }</loc>\
      <news:news> \
      <news:publication> \
      <news:name>ecohubmap</news:name>\
      <news:language>en</news:language>\
      </news:publication>\
      <news:publication_date>${moment(orgToFile.date).format(
        "YYYY-MM-DD"
      )}</news:publication_date>\
      <news:title>${nameEncode(orgToFile.title)} </news:title>\
      </news:news> \
      <lastmod>${moment(orgToFile.date).format("YYYY-MM-DD")}</lastmod>\
      <priority>0.8</priority>\
   </url>\
`;
  }
  const fileValue = `<?xml version="1.0" encoding="UTF-8"?>\
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:news="http://www.google.com/schemas/sitemap-news/0.9">\
${urls}
</urlset> `;

  return fileValue;
};
